import { Viewport } from 'react-leaflet';
const bbox = require('geojson-bbox');

function getEmptyFarmCenter(farm: Farm): Viewport {
  return {
    center: farm.geometry.coordinates as [number, number],
    zoom: 15
  };
}

function getMultiFieldCenter(fields: Field[]): Viewport {
  const [minLng, minLat, maxLng, maxLat] = bbox({
    type: 'MultiPolygon',
    coordinates: fields.map((f: Field) => f.geometry.coordinates)
  });

  return {
    center: [(minLat + maxLat) / 2, (minLng + maxLng) / 2],
    zoom: 15
  };
}

export function calculateFarmViewport(
  farm: Farm,
  selectedId?: string | null
): Viewport | null {
  if (!farm.fields || !farm.fields.length) {
    return getEmptyFarmCenter(farm);
  }

  let fields = farm.fields;

  if (selectedId) {
    fields = fields.filter(f => f.id === selectedId);
  }

  return getMultiFieldCenter(fields);
}

export function calculateFieldViewport(field: Field | null): Viewport | null {
  if (!field) {
    return null;
  }

  return getMultiFieldCenter([field]);
}



// WEBPACK FOOTER //
// ./src/utils/ViewportCalculator.ts